import * as React from 'react'
import cn from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/pro-light-svg-icons'
import { AccountingOnboardingSyncedPreOfferStatus } from '../../../../../__generated__/globalTypes'
import Spinner from '../../../../../components/spinner'
import styles from './progress.module.scss'
import { dropRight } from 'lodash-es'

interface IProgressProps {
  status: AccountingOnboardingSyncedPreOfferStatus
  notStarted?: boolean
}

export default function Progress({ status, notStarted }: IProgressProps) {
  const {
    pendingOrganizationSummarySync,
    organizationSummarySynced,
    pendingBankSync,
    fetchAccountsDone,
    bankSynced,
    done,
    syncFailed,
    rejected,
  } = AccountingOnboardingSyncedPreOfferStatus

  const progressStates = [
    pendingOrganizationSummarySync,
    organizationSummarySynced,
    pendingBankSync,
    fetchAccountsDone,
    bankSynced,
    done,
    syncFailed,
    rejected,
  ]

  const renderLineHeight = () => {
    const successfulStatuses = dropRight(progressStates, 3)
    const statusHeight = 100 / successfulStatuses.length

    return `${statusHeight * (successfulStatuses.indexOf(status) + 1)}%`
  }

  return (
    <div className={styles.root}>
      <Circle
        lede="Synkning med Skatteverket för att hämta företagsuppgifter"
        loading={!notStarted && [pendingOrganizationSummarySync].includes(status)}
        success={!notStarted && progressStates.indexOf(organizationSummarySynced) <= progressStates.indexOf(status)}
        title="Skatteverket"
      />
      <div className={styles.lineWrapper}>
        <div className={styles.line} />
        <div
          className={styles.progressLine}
          style={{
            height: !notStarted ? renderLineHeight() : '0%',
          }}
        />
      </div>
      <Circle
        lede="Synkning med Banken för att hämta företagets transaktioner"
        loading={!notStarted && [pendingBankSync, fetchAccountsDone].includes(status)}
        success={!notStarted && progressStates.indexOf(bankSynced) <= progressStates.indexOf(status)}
        title="Banken"
      />
    </div>
  )
}

const Circle = ({
  loading,
  success,
  title,
  lede,
}: {
  loading?: boolean
  success?: boolean
  title: string
  lede: string
}) => (
  <div className={styles.circleWrapper}>
    <div className={cn(styles.circle, loading && styles.circleLoading, success && styles.circleSuccess)}>
      {loading && <Spinner className={styles.spinner} variant="white" />}

      {success && (
        <i className={styles.checkMark}>
          <FontAwesomeIcon icon={faCheck} />
        </i>
      )}
    </div>
    <div>
      <h4>{title}</h4>
      <p>{lede}</p>
    </div>
  </div>
)
